<template>
  <!-- Avertissement de la fiche contact (Chady, 2026-10-29) : la fiche seule dit
       qui est le client pour l'e-factura — un CUI (ou TVA, ou J) encodé = une
       société ; rien = une personne physique, et la facture part avec 13 zéros
       que l'ANAF ne remet à personne (cas RO2026_01525, Recep Plus). Le
       commutateur COMPANY/PERSON n'est pas lu. Discret, en anglais (langue de
       l'UI) et en roumain (langue des encodeurs), affiché tant que la fiche n'a
       aucun identifiant. -->
  <div v-if="visible" class="cui-notice mt-4">
    <feather-icon icon="AlertTriangleIcon" svgClasses="h-4 w-4" class="cui-notice__icon" />
    <div class="cui-notice__text">
      <div><b>Company?</b> Enter its CUI (or VAT number) before invoicing. Without a CUI the ERP treats the customer as a
        private person: the e-Factura leaves with 0000000000000 and the ANAF does not deliver it to the customer.</div>
      <div class="cui-notice__ro"><b>Societate?</b> Completați CUI-ul (sau codul de TVA) înainte de facturare. Fără CUI, clientul
        este tratat ca persoană fizică: e-Factura pleacă cu 0000000000000 și ANAF nu o transmite clientului.</div>
    </div>
  </div>
</template>

<script>
import { buyerIdentifierOnRecord } from '@/helpers/efacturaUbl.js'

export default {
  name: 'CuiNotice',
  props: {
    // La fiche en cours d'édition : vat_number, cui, inmatriculare_j.
    person: { type: Object, default: null }
  },
  computed: {
    visible () {
      const rec = buyerIdentifierOnRecord(this.person)
      return rec.kind === 'PERSON' && !rec.id
    }
  }
}
</script>

<style scoped>
.cui-notice {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 8px 12px;
  border-left: 3px solid #d9822b;
  background: #fcf1dc;
  border-radius: 4px;
  font-size: 0.8rem;
  line-height: 1.45;
  color: #3a3f3c;
}
.cui-notice__icon {
  color: #855409;
  margin-top: 2px;
  flex: 0 0 auto;
}
.cui-notice__text {
  min-width: 0;
}
.cui-notice__ro {
  margin-top: 4px;
  color: #6b716d;
}
</style>
